'use client';

import { Header } from './Header';
import { HeroSection } from './HeroSection';
import { FeaturesSection } from './FeaturesSection';
import { AnimatedBackground } from './AnimatedBackground';
import { CreditsFooter } from '@/components/shared/CreditsFooter';
import { useTheme } from '@/contexts/ThemeContext';

export function Home() {
  const { isDark } = useTheme();

  return (
    <div className={`w-full min-h-screen ${isDark ? 'bg-black text-white' : 'bg-blue-50 text-gray-900'} relative overflow-x-hidden overflow-y-auto`}>
      <AnimatedBackground isDark={isDark} />
      <div className="relative z-10">
        <Header />
        <HeroSection isDark={isDark} />
        <FeaturesSection isDark={isDark} />
        <CreditsFooter isDark={isDark} />
      </div>
    </div>
  );
}